{
  "languages": {
    "select": "Select language",
    "english": "En",
    "french": "FR",
    "german": "DE",
    "spanish": "ES",
    "portuguese": "PT"
  },
  "nav": {
    "dashboard": "Dashboard",
    "clients": "Clients",
    "myBookings": "My Bookings",
    "loginTrainer": "Trainer Login",
    "login": "Login",
    "logout": "Logout",
    "accountSettings": "Account Settings",
    "changePassword": "Change Password",
    "home": "Home",
    "pricing": "Pricing",
    "contact": "Contact",
    "affiliate": "Affiliate Program",
    "product": "Product",
    "yogaStudioSoftware": "Yoga Studio Software",
    "pilatesStudioSoftware": "Pilates Studio Software",
    "cantienicaStudioSoftware": "CANTIENICA Studio Software",
    "resources": "Resources",
    "guides": "Guides",
    "blog": "Blog"
  },
  "accountSettings": {
    "title": "Account Settings",
    "editTitle": "Edit Profile",
    "firstName": "First Name",
    "lastName": "Last Name",
    "email": "Email",
    "phone": "Phone",
    "updateSuccess": "Profile Updated",
    "updateSuccessMessage": "Your profile has been successfully updated",
    "firstNameRequired": "First name is required",
    "lastNameRequired": "Last name is required",
    "dangerZone": "Danger Zone",
    "deleteAccount": "Delete My Account",
    "deleteWarning": "This will permanently delete your account and all associated data. This action cannot be undone.",
    "confirmDelete": "Are you sure you want to delete your account?",
    "deleteSuccess": "Account deleted",
    "deleteSuccessMessage": "Your account has been deleted successfully.",
    "deleteDialog": {
      "title": "Delete My Account",
      "description": "Are you sure you want to delete your account and all associated data? This action cannot be undone."
    }
  },
  "password": {
    "changeTitle": "Change Password",
    "current": "Current Password",
    "new": "New Password",
    "confirm": "Confirm New Password",
    "error": "Error",
    "mismatch": "New passwords do not match",
    "updateSuccess": "Password Updated",
    "updateSuccessMessage": "Your password has been successfully updated",
    "currentPasswordRequired": "Current password is required",
    "newPasswordRequired": "New password is required",
    "confirmPasswordRequired": "Password confirmation is required",
    "passwordsDoNotMatch": "Passwords do not match"
  },
  "classes": {
    "title": "Available Classes",
    "bookIntro": "Book your next session with our expert trainers",
    "bookNow": "Book now",
    "online": "Online",
    "spots": "spots left",
    "noClassesAvailableClearFilter": "No classes available. Please try another date or clear the filter to see all available classes.",
    "noClassesAvailable": "No classes available.",
    "confirmBookingTitle": "Class Booked!",
    "confirmBookingDescription": "You have successfully booked {title} with {trainer} on {date} at {time}"
  },
  "classForm": {
    "title": "Title",
    "datetime": "Date/Time",
    "duration": "Duration",
    "capacity": "Capacity",
    "price": "Price",
    "currency": "Currency",
    "currencyOptions": {
      "eur": "EUR",
      "usd": "USD",
      "gbp": "GBP"
    },
    "status": "Status",
    "statusOptions": {
      "available": "Available",
      "canceled": "Canceled",
      "hidden": "Hidden"
    },
    "location": "Location",
    "locationOptions": {
      "studio": "Studio",
      "online": "Online"
    },
    "trainer": "Trainer",
    "isRecurring": "Recurring Class",
    "submit": "Submit",
    "repeatEvery": "Repeats every",
    "repeatPeriod": "Period",
    "repeatPeriodOptions": {
      "week": "Week",
      "month": "Month",
      "year": "Year"
    },
    "maxEvents": "Maximum number of events",
    "validation": {
      "titleRequired": "Title must be at least 2 characters.",
      "minCapacity": "Capacity must be at least 1.",
      "maxEvents": "Maximum number of events must be between 1 and 24."
    },
    "cancelClass": "Cancel Class",
    "deleteClass": "Delete Class",
    "cancelDialog": {
      "title": "Cancel Class",
      "description": "Are you sure you want to cancel this class? This action cannot be undone."
    },
    "deleteDialog": {
      "title": "Delete Class",
      "description": "Are you sure you want to delete this class? This action cannot be undone."
    },
    "cancelSuccess": {
      "title": "Class Canceled",
      "description": "The class has been successfully canceled."
    },
    "deleteSuccess": {
      "title": "Class Deleted",
      "description": "The class has been successfully deleted."
    },
    "createSuccess": {
      "title": "Class Created",
      "description": "The class has been successfully created."
    }
  },
  "classCard": {
    "editClass": "Edit Class",
    "enrolled": "enrolled",
    "status": "Status",
    "at": "at",
    "min": "Min.",
    "spots": "spots",
    "location": "Location",
    "trainer": "Trainer",
    "enrolledClients": "Enrolled Clients",
    "noEnrolledClients": "No Enrolled Clients.",
    "confirmRemoval": "Confirm Removal",
    "confirmRemovalDescription": "Are you sure you want to remove {{name}} from the class?",
    "clientHistory": "Booking History for {{name}}",
    "lastBookings": "Below is the history of the last 10 bookings made by this client.",
    "bookNow": "Book now",
    "booked": "Booked",
    "classFullyBooked": "Fully booked"
  },
  "bookingSummary": {
    "title": "Booking Summary",
    "description": "Please review your class booking details",
    "min": "Min.",
    "cancellationPolicy": "You can cancel your booking up to 24 hours before the class starts at no cost. For cancellations made less than 24 hours before the start time, the full fee will be charged.",
    "agreeText": "By proceeding, you agree to our",
    "terms": "Terms",
    "and": "and",
    "privacyPolicy": "Privacy Policy",
    "confirmBooking": "Confirm Booking",
    "sessions": "Number of Sessions",
    "selectSessions": "Select the number of sessions",
    "sessionsDescription": "Please select how many sessions you want to book.",
    "bookingFailedTitle": "Booking Failed",
    "bookingFailedDescription": "Unable to book the class. Please try again later.",
    "bookingFullDescription": "This class is fully booked. Please choose another class or date."
  },
  "login": {
    "title": "Sign In",
    "description": "Enter your credentials to access your account",
    "email": "Email",
    "emailPlaceholder": "Enter your email",
    "password": "Password",
    "signIn": "Sign In",
    "forgotPassword": "Forgot password?"
  },
  "terms": {
    "title": "Terms and Conditions",
    "scope": {
      "title": "1. Scope",
      "description": "These Terms and Conditions (\"Terms\") apply to the use of our fitness studio booking platform (\"App\"), which allows fitness studios to publish their classes and users to book them. By registering and using the App, you agree to be bound by these Terms."
    },
    "services": {
      "title": "2. Services Provided",
      "description": "Our App enables users to:",
      "features": {
        "browse": "Browse and book fitness classes offered by participating studios.",
        "manage": "Manage their bookings through their user account."
      },
      "disclaimer": "We act solely as a platform provider and are not responsible for the quality, availability, or execution of the fitness classes offered by third-party studios."
    },
    "registration": {
      "title": "3. User Registration and Accounts",
      "points": {
        "accurateInfo": "Users must provide accurate and up-to-date information during registration.",
        "confidentiality": "Each user is responsible for maintaining the confidentiality of their account credentials.",
        "payment": "This app is completely free for users. We do not charge any fees for class bookings, and users will never be asked to make payments through the app."
      }
    },
    "booking": {
      "title": "4. Booking and Cancellation",
      "points": {
        "binding": "Bookings are binding once confirmed.",
        "cancellationPolicy": "Each fitness studio sets its own cancellation policy, which users must adhere to.",
        "refunds": "We are not responsible for refunds or cancellations; these are handled by the respective fitness studios."
      }
    },
    "responsibilities": {
      "title": "5. User Responsibilities",
      "points": {
        "lawfulUse": "Users agree to use the App lawfully and not for fraudulent activities.",
        "studioRules": "Users must follow the rules and policies of the fitness studios they book with."
      }
    },
    "liability": {
      "title": "6. Liability",
      "points": {
        "injuries": "We are not liable for any injuries, damages, or losses occurring during or as a result of participating in booked classes.",
        "technicalMalfunctions": "Our liability for damages due to technical malfunctions of the App is limited to cases of gross negligence or intent."
      }
    },
    "dataProtection": {
      "title": "7. Data Protection",
      "points": {
        "gdpr": "User data is processed in accordance with our Privacy Policy and the GDPR."
      }
    },
    "termination": {
      "title": "8. Termination and Account Suspension",
      "points": {
        "suspension": "We reserve the right to suspend or terminate accounts that violate these Terms."
      }
    },
    "governingLaw": {
      "title": "9. Governing Law and Dispute Resolution",
      "points": {
        "germanLaw": "These Terms are governed by German law.",
        "disputeResolution": "Any disputes shall be settled in German courts."
      }
    }
  },
  "privacy": {
    "title": "Privacy Policy",
    "introduction": {
      "title": "1. Introduction",
      "description": "This Privacy Policy explains how we collect, use, and protect your personal data when using our App in accordance with the General Data Protection Regulation (GDPR) and German data protection laws."
    },
    "dataController": {
      "title": "2. Data Controller",
      "description": "PraxiPro is the data controller responsible for processing your personal data."
    },
    "dataCollected": {
      "title": "3. Data Collected",
      "description": "We collect the following data:",
      "points": {
        "account": "Only name and email are required for account creation.",
        "booking": "Booking history and preferences."
      }
    },
    "purpose": {
      "title": "4. Purpose of Data Processing",
      "description": "Your data is processed for the following purposes:",
      "points": {
        "account": "Providing and managing your account.",
        "booking": "Facilitating class bookings.",
        "compliance": "Ensuring compliance with our Terms and improving our services."
      }
    },
    "dataSharing": {
      "title": "5. Data Sharing",
      "points": {
        "fitnessStudios": "Your data is only shared with the Fitness studios to facilitate your booking."
      }
    },
    "dataSecurity": {
      "title": "6. Data Security",
      "description": "We implement technical and organizational measures to protect your data against unauthorized access and misuse."
    },
    "dataRetention": {
      "title": "7. Data Retention",
      "points": {
        "retention": "We retain your data as long as necessary for the fulfillment of our services or as legally required.",
        "deletion": "If you choose to delete your account, the app will permanently remove all data associated with your account. No personal information or related data will be retained, and your information will be completely erased from our system."
      }
    },
    "userRights": {
      "title": "8. Your Rights",
      "description": "As a user, you have the following rights under GDPR:",
      "points": {
        "access": "Right to access, correct, or delete your personal data.",
        "object": "Right to object to data processing.",
        "portability": "Right to data portability."
      }
    },
    "contact": {
      "title": "9. Contact Information",
      "description": "For any privacy-related inquiries, please contact us at [hello@praxipro.de]."
    },
    "changes": {
      "title": "10. Changes to This Policy",
      "description": "We may update this Privacy Policy periodically. Users will be informed of significant changes."
    },
    "consent": {
      "description": "By using our App, you consent to the terms outlined in this Privacy Policy."
    }
  },
  "clientDashboard": {
    "title": "My Bookings",
    "bookedClasses": "My Booked Classes",
    "cancelSuccess": {
      "title": "Booking Canceled",
      "description": "Your class booking has been successfully canceled"
    },
    "cancelDialog": {
      "title": "Cancel Booking",
      "description": "Are you sure you want to cancel this booking? This action cannot be undone."
    },
    "cannotCancel": "Cannot cancel within 24h"
  },
  "dashboard": {
    "createNewClass": "Create New Class",
    "upcomingClasses": "Upcoming Classes",
    "historicalClasses": "Historical Classes",
    "createClass": {
      "title": "Create New Class",
      "description": "Fill in the details for your new class.",
      "create": "Create Class"
    },
    "editClass": {
      "title": "Edit Class",
      "description": "Update the details for your class.",
      "update": "Update Class"
    },
    "stats": {
      "totalClasses": "Total Classes",
      "totalStudents": "Total Students"
    }
  },
  "forgotPassword": {
    "title": "Reset Password",
    "description": "Enter your email address and we'll send you a link to reset your password.",
    "emailLabel": "Email",
    "emailPlaceholder": "Enter your email",
    "sendResetLinkButton": "Send Reset Link",
    "sendingButton": "Sending...",
    "backToLoginButton": "Back to login",
    "rememberPassword": "Remember your password?",
    "toastSuccessTitle": "Reset Password Link Sent",
    "toastSuccessDescription": "If an account exists with this email, you will receive a password reset link.",
    "toastErrorTitle": "Error resetting password",
    "toastErrorDescription": "There was an issue resetting your password. Please try again later."
  },
  "resetPassword": {
    "title": "Reset Password",
    "description": "Enter your new password to complete the reset process.",
    "confirmRegistrationTitle": "Choose Password",
    "confirmRegistrationDescription": "Enter your new password to complete the registration process.",
    "newPasswordLabel": "New Password",
    "confirmPasswordLabel": "Confirm Password",
    "sendResetLinkButton": "Submit Reset",
    "sendingButton": "Submitting...",
    "toastPasswordMismatchTitle": "Passwords do not match",
    "toastPasswordMismatchDescription": "Please ensure both passwords are the same.",
    "toastSuccessTitle": "Password Reset Successful",
    "toastSuccessDescription": "Your password has been successfully reset.",
    "toastErrorTitle": "Error resetting password",
    "toastErrorDescription": "There was an issue resetting your password. Please try again later."
  },
  "authDialog": {
    "loginTitle": "Login to Book Class",
    "signUpTitle": "Sign Up to Book Class",
    "loginDescription": "Please login to confirm your booking",
    "signUpDescription": "Create an account to book classes",
    "firstName": "First Name",
    "firstNamePlaceholder": "John",
    "lastName": "Last Name",
    "lastNamePlaceholder": "Doe",
    "email": "Email",
    "emailPlaceholder": "john@example.com",
    "password": "Password",
    "forgotPassword": "Forgot password?",
    "loginButton": "Login & Book",
    "signUpButton": "Sign Up & Book",
    "switchToSignUp": "Need an account? Sign up",
    "switchToLogin": "Already have an account? Login",
    "loginFailed": "Login failed. Please try again.",
    "emailAlreadyExists": "This email is already registered. Please sign in instead. If you forgot your password, use the “Forgot password” option.",
    "registrationFailed": "Registration failed. Please try again.",
    "registrationSuccessful": "Registration successful! Please check your email to confirm your email address."
  },
  "common": {
    "class": "Class",
    "date": "Date",
    "time": "Time",
    "duration": "Duration",
    "trainer": "Trainer",
    "price": "Price",
    "location": "Location",
    "status": "Status",
    "actions": "Actions",
    "minutes": "minutes",
    "completed": "Completed",
    "cancel": "Cancel",
    "delete": "Delete",
    "close": "Close",
    "booked": "Booked",
    "canceled": "Canceled",
    "keepBooking": "Keep Booking",
    "confirmCancel": "Yes, Cancel",
    "backToClasses": "Back to Classes",
    "save": "Save Changes",
    "logout": "Logout",
    "pickMonth": "Pick a month",
    "pickDate": "Pick a date",
    "clear": "Clear",
    "remove": "Remove",
    "submit": "Submit",
    "pleaseWait": "Please Wait..."
  },
  "contactUs": {
    "title": "Need Help? Contact Our Booking Software Experts",
    "getInTouch": "Get in touch to register your studio and start your free trial",
    "subHeading": "We'd love to hear from you! Whether you have a question about features, pricing, or anything else — our team is ready to answer all your questions.",
    "fillOutContactForm": "Fill out the form and we'll get back to you as soon as possible.",
    "name": "Name",
    "enterName": "Enter your name",
    "email": "Email",
    "enterEmail": "Enter your email",
    "studioName": "Studio Name",
    "enterStudioName": "Enter studio name",
    "message": "Message",
    "enterMessage": "Enter your message",
    "sendMessage": "Send Message",
    "sendingMessage": "Sending Message",
    "submit": "Submit",
    "submitting": "Submitting...",
    "nameMin": "Name must be at least 2 characters.",
    "emailInvalid": "Please enter a valid email address.",
    "messageMin": "Message must be at least 10 characters.",
    "requestSent": "Request Sent",
    "weWillGetBack": "We'll get back to you shortly!",
    "toastErrorTitle": "Error Occurred",
    "toastErrorDescription": "An error occurred while processing your request. Please try again later.",
    "alertStudioProfessional": "This form is intended for studio professionals seeking to register their studio.",
    "needSupport": {
      "title": "Need support?",
      "description": "Get instant answers."
    },
    "feedback": {
      "title": "Feedback?",
      "description": "Tell us about it here."
    },
    "reportIssue": {
      "title": "Report issue",
      "description": "Get priority support."
    },
    "community": {
      "title": "Community",
      "description": "Connect with fellow users."
    }
  },
  "landing": {
    "title": "Studio Management Software for Fitness Studios",
    "heroTitle": "Modern Studio App for Yoga, Pilates, Physiotherapy & CANTIENICA",
    "heroDescription": "The all-in-one platform for fitness studio owners to manage classes, clients, and grow their business efficiently.",
    "ctaText": "Start Free Trial",
    "featuresSectionTitle": "Everything You Need to Run Your Studio",
    "featuresSectionDescription": "Powerful tools designed specifically for fitness studio owners",
    "classManagementTitle": "Class Management",
    "classManagementDescription": "Effortlessly manage your class schedule, handle bookings, and track attendance in real-time",
    "clientManagementTitle": "Client Management",
    "clientManagementDescription": "Keep track of your clients, their booking history, and manage memberships all in one place",
    "businessAnalyticsTitle": "Business Analytics",
    "businessAnalyticsDescription": "Get insights into your studio's performance with detailed reports and analytics",
    "benefitsSectionTitle": "Grow Your Business with Smart Tools",
    "benefitsSectionDescription": "Smart tools to help your business grow.",
    "benefit1": "Reduce no-shows with automated reminders",
    "benefit2": "Increase revenue with flexible pricing options",
    "benefit3": "Save time with automated scheduling",
    "benefit4": "Improve client retention with engagement tools",
    "benefit5": "Make data-driven decisions with detailed analytics",
    "benefit6": "Streamline operations with integrated tools",
    "ctaSectionTitle": "Ready to Transform Your Studio Management?",
    "ctaSectionDescription": "Join successful studio owners who have streamlined their operations with our platform.",
    "featuredStudiosTitle": "Featured Studios Using FitCalendar",
    "featuredStudiosIntro": "Join these successful fitness businesses that have transformed their operations with our platform",
    "physiotherapyPractice": "Physiotherapy Practice",
    "onlineBooking": "Online Booking",
    "howFitCalendarWorksTitle": "How FitCalendar Works",
    "howFitCalendarWorksIntro": "Get up and running with our simple, four-step process",
    "howFitCalendarWorksStep1Title": "Sign Up",
    "howFitCalendarWorksStep1Intro": "Create your account and set up your profile in minutes",
    "howFitCalendarWorksStep2Title": "Build",
    "howFitCalendarWorksStep2Intro": "Add your classes and get your studio ready for bookings",
    "howFitCalendarWorksStep3Title": "Integrate",
    "howFitCalendarWorksStep3Intro": "Connect with your existing tools and add your booking link to your website",
    "howFitCalendarWorksStep4Title": "Grow",
    "howFitCalendarWorksStep4Intro": "Focus on your clients while we handle the administrative work",
    "viewPricing": "View Pricing",
    "rating": "Rating",
    "happyUsers": "Happy Users",
    "freeTrial": "Free Trial",
    "realTimeDashboard": "Real-time studio dashboard",
    "trackYourStudioPerformance": "Track your studio performance"
  },
  "pricing": {
    "title": "Pricing",
    "header": "Affordable Fitness Booking Software Plans",
    "subHeader": "One affordable subscription for everything your practice needs — class scheduling, client bookings, and studio management made easy.",
    "freeTrial": "Free Trial",
    "freeTrialDesc": "For studios testing the platform",
    "freeTrialFeatures": [
      "14-day full access",
      "Basic calendar management",
      "Up to 5 classes per week",
      "Basic client profiles"
    ],
    "startFreeTrial": "Start Free Trial",
    "standard": "Standard",
    "standardDesc": "Per studio, billed monthly",
    "standardFeatures": [
      "Unlimited classes and appointments",
      "Advanced calendar management",
      "Online booking for clients",
      "Full client management system",
      "Payment processing integration",
      "Basic reporting and analytics",
      "Email Support"
    ],
    "subscribeNow": "Subscribe Now",
    "annual": "Annual",
    "annualDesc": "Save 20% with annual billing",
    "annualFeatures": [
      "All Standard features",
      "2 months free (€16/mo equivalent)",
      "Priority customer support",
      "Advanced reporting and analytics"
    ],
    "subscribeAnnually": "Subscribe Annually",
    "popularPlan": "Most Popular",
    "perMonth": "/mo",
    "perYear": "/year",
    "faqsTitle": "Frequently Asked Questions",
    "faqsQ1": "Can I upgrade or downgrade my plan?",
    "faqsA1": "Yes, you can upgrade to an annual plan at any time. Downgrading from annual to monthly is available when your annual subscription ends.",
    "faqsQ2": "Do you offer multi-studio discounts?",
    "faqsA2": "Yes! For studios with multiple locations, we offer volume discounts. Contact our sales team for custom pricing.",
    "faqsQ3": "What payment methods do you accept?",
    "faqsA3": "We accept all major credit cards and PayPal. For annual plans, we can also accommodate bank transfers.",
    "faqsQ4": "Is there a setup fee?",
    "faqsA4": "No, there are no hidden fees. Your subscription covers everything including setup, hosting, and regular updates."
  },
  "affiliate": {
    "title": "Affiliate Program",
    "heading": "💼 Join Our Affiliate Program",
    "description": "Earn money by referring Yoga, Pilates, Fitness Instructors, Physiotherapists, CANTIENICA Professionals, and Movement Coaches to FitCalendar. It’s easy, rewarding, and grows with you.",
    "rewardOne": {
      "amount": "💶 96 €",
      "text": "for each new user who subscribes for one full year."
    },
    "rewardTwo": {
      "amount": "📅 8 €/month",
      "text": "for one year per user if they choose monthly billing."
    },
    "rewardThree": {
      "title": "🏆 Lifetime Bonus:",
      "description": "Refer over 50 paying users and receive",
      "amount": "3 €/month",
      "forever": "forever"
    },
    "ctaHeading": "🎉 Get Started Today",
    "ctaDescription": "Fill out the form below and receive your unique referral code via email. Share it and start earning!",
    "form": {
      "firstName": "First Name",
      "lastName": "Last Name",
      "email": "Email Address",
      "submit": "Get My Referral Code",
      "loading": "Registering..."
    },
    "firstNameMin": "First name is required",
    "lastNameMin": "Last name is required",
    "emailInvalid": "Invalid email address"
  },
  "register": {
    "title": "Studio Registration",
    "description": "Register your studio and start your free trial",
    "name": "Name",
    "enterName": "Enter your name",
    "email": "Email",
    "enterEmail": "Enter your email",
    "studioName": "Studio Name",
    "enterStudioName": "Enter studio name",
    "message": "Message",
    "enterMessage": "Enter your message",
    "sendMessage": "Send Message",
    "sendingMessage": "Sending Message",
    "submit": "Submit",
    "submitting": "Submitting...",
    "nameMin": "Name must be at least 2 characters.",
    "emailInvalid": "Please enter a valid email address.",
    "messageMin": "Message must be at least 10 characters.",
    "requestSent": "Request Sent",
    "weWillGetBack": "We'll get back to you shortly!",
    "toastErrorTitle": "Error Occurred",
    "toastErrorDescription": "An error occurred while processing your request. Please try again later.",
    "alertStudioProfessional": "This form is intended for studio professionals seeking to register their studio."
  },
  "guides": {
    "title": "Resource Library"
  },
  "blog": {
    "title": "Yoga, Pilates, CANTIENICA & Fitness Tips"
  },
  "clients": {
    "title": "Clients List",
    "description": "Manage your fitness clients and view their booking history.",
    "listTitle": "Client Database",
    "searchPlaceholder": "Search by name or email...",
    "searchButton": "Search",
    "searching": "Searching...",
    "table.name": "Name",
    "table.email": "Email",
    "table.totalBookings": "Total Bookings",
    "table.actions": "Actions",
    "table.class": "Class",
    "table.date": "Date",
    "table.time": "Time",
    "table.duration": "Duration",
    "table.price": "Price",
    "table.status": "Status",
    "viewClasses": "View Bookings",
    "loading": "Loading...",
    "noClientsFound": "No clients found.",
    "searchError.apiTitle": "Error",
    "searchError.apiDescription": "Failed to load data from the server.",
    "searchError.title": "Search Warning",
    "minLengthWarning": "Please enter at least 3 characters to search.",
    "bookingsTitle": "Bookings for {{name}}",
    "noBookings": "No booking data available.",
    "bookingsDescription": "Below is the history of all bookings made by this client.",
    "status.booked": "Booked",
    "status.canceled": "Canceled"
  }
}